import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomImageDialog } from "../ClientSearch/SearchByPrompt";
import { NumberField } from "../../../components/common/CustomNumberField";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useSelector } from "react-redux";
import { CustomButton } from "../../../components/common/LoadingButton";
import { CustomTextField } from "../../../components/common";
import GroupRadioButton from "./GroupRadioButton";

const CandidateBonusDialog = ({
  selectedOptions,
  open,
  onClose,
  formik,
  value,
  setValue,
}) => {
  const { loading } = useSelector((state) => state.candidate);

  return (
    <CustomImageDialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "Urbane-Demibold",
          fontSize: "16px",
          fontWeight: 600,
        }}
      >
       Information
        <IconButton
          edge="end"
          color="error"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          m: 1,
          width: "500px",
        }}
      >
        <Box
          noValidate
          autoComplete="off"
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Grid container alignItems="center" spacing={2} m={1}>
            {(selectedOptions === "Hired"  ||
              selectedOptions === "Offer Extended") && (
              <NumberField
                id="candidate_totalamount"
                label={"Annual Compensation and Bonus (cash only)"}
                name="candidate_totalamount"
                autoComplete="candidate_totalamount"
                placeholder="Enter Amount"
                formik={formik}
                numberFlag={true}
                endAdornmentIcon={AttachMoneyIcon}
                inputProps={{
                  maxLength: 15,
                }}
              />
            )}

            {selectedOptions === "Rejected" && (
              <>
                <Grid item xs={12}>
                  <GroupRadioButton value={value} setValue={setValue} />
                </Grid>
                {value === "Other" && (
                  <Grid item xs={12} md={12}>
                    <CustomTextField
                      id="other_reason"
                      label="Other Reason"
                      name="other_reason"
                      autoComplete="other_reason"
                      placeholder="Enter your reason"
                      formik={formik}
                      // disabled={search_id}
                    />
                  </Grid>
                )}
              </>
            )}
            {/* <NumberField
              id="candidate_baseamount"
              label={"Base Amount"}
              name="candidate_baseamount"
              autoComplete="candidate_baseamount"
              placeholder="Enter Base Amount"
              formik={formik}
              numberFlag={true}
              endAdornmentIcon={AttachMoneyIcon}
              inputProps={{
                maxLength: 15,
              }}
            /> */}
            {/* <Grid item xs={6}>
              <Typography variant="body1" fontSize={"18px"}>
                Total:{" "}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                sx={{ marginTop: "10px", textAlign: "end" }}
              >
                $
                {new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(parseFloat(formik.values.candidate_totalamount || 0))}
              </Typography>
            </Grid> */}
          </Grid>
          <div className="text-center">
            <CustomButton
              color="primary"
              type="submit"
              disabled={loading}
              sx={{ mt: 4, px: 4 }}
            >
              {loading ? <CircularProgress size={24} /> : "Submit"}
            </CustomButton>
          </div>
        </Box>
      </DialogContent>
    </CustomImageDialog>
  );
};

export default CandidateBonusDialog;
